import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { Admin } from '../../api/models/admin/admin.model';
import { AccountState } from './accounts/account.entity';
import { UserState } from './users/user.entity';
import { DeviceState } from './devices/device.entity';

export const adminAdapter: EntityAdapter<Admin> = createEntityAdapter<Admin>();

export interface AdminState extends EntityState<Admin> {
    ids: number[];
    entities: any;
    users: UserState;
    accounts: AccountState;
    devices: DeviceState;
    //firmwares
}

